module.exports = __webpack_public_path__ + "img/bpBJGreen.8de3b872.jpg";